import type { Repository } from "./gen/gd_platform_pb";

type Paged = { pages: { repositories: Repository[] }[] };

/**
 * `data` (a cached list of repositories, plain or paged) with `r` in place of its old self.
 * Lists are cached in both shapes under "repos", so whatever updates one must take either.
 */
export function withRepository<T>(data: T, r: Repository): T {
  const swap = (list: Repository[]) => list.map((x) => (x.owner === r.owner && x.name === r.name ? r : x));
  if (Array.isArray(data)) return swap(data) as T;
  const paged = data as Paged | undefined;
  if (paged && Array.isArray(paged.pages)) return { ...paged, pages: paged.pages.map((p) => ({ ...p, repositories: swap(p.repositories ?? []) })) } as T;
  return data;
}
